var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"color-line"},_vm._l((_vm.colors),function(item,index){return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.max || index < _vm.max),expression:"!max || index < max"}],key:index,staticClass:"item",style:({background: item, height: _vm.height})})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }